import axios from 'axios'
import axiosRetry from 'axios-retry'
import config from 'config/config'
import {
  ApiFailure,
  logoutAction,
  setErrorForStatus400,
  setErrorForStatus5021
} from 'index'
import cookie from 'js-cookie'
import { beforeUnloadHandler } from 'util/beforeUnloadHandler'

// Global Axios Settings
axios.defaults.baseURL = `${config.defaults.api_url}/api/v26`
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.timeout = 8000
axios.defaults.headers.post['apiKey'] = config.defaults.api_key
axios.defaults.headers.get['apiKey'] = config.defaults.api_key
axios.defaults.headers.put['apiKey'] = config.defaults.api_key

axios.interceptors.request.use(async (axiosConfig: any) => {
  axiosConfig.headers.Authorization = `Bearer ${cookie.get('token')}`
  return axiosConfig
})

axios.interceptors.response.use(
  (value): any => {
    if (
      value.config.url?.match(
        /student\/(formatives|benchmarks)\/\d+\/\d+\/submit/
      )
    ) {
      ApiFailure.setSubmitApiError(false)
    }
    ApiFailure.setApiError(false, null!)
    setErrorForStatus400(false)
    return Promise.resolve(value.data)
  },
  (error) => {
    const { config, response } = error
    const { url } = config
    const isResetRequired = !url.includes('student-login')
    if (isResetRequired) {
      if (
        response &&
        response.status === 400 &&
        response.data.status_code === 5021
      ) {
        setErrorForStatus5021(true)
      } else if (response && response.status >= 400 && response.status < 500) {
        if (response?.data?.message === 'Token expired.') {
          window.removeEventListener('beforeunload', beforeUnloadHandler)
          window.location.href = '/'
          logoutAction()
        } else {
          setErrorForStatus400(true)
        }
      } else if (
        url.match(/student\/(formatives|benchmarks)\/\d+\/\d+\/submit/)
      ) {
        ApiFailure.setSubmitApiError(true)
      } else {
        ApiFailure.setApiError(true, null!)
      }
    }
    return Promise.reject(error)
  }
)

axiosRetry(axios, {
  retries: 5,
  retryDelay: (retryCount) => 5 * 1000,
  shouldResetTimeout: true,
  retryCondition: (error) => {
    if (error) {
      const { response } = error
      if (response) return !(response?.status >= 400 && response.status < 500)
    }
    return true
  }
})

const http = {
  request: axios.request,
  get: axios.get,
  post: axios.post,
  put: axios.put,
  patch: axios.patch,
  delete: axios.delete
}

export default http
